import {CircularProgress} from "@mui/material";

const doctorKey = (doctor, index) =>
  doctor?.id ?? doctor?.user_id ?? `${doctor?.first_name}-${index}`;

/** Shared doctor finder used by referral and direct-message workflows. */
export function DoctorSearchModal({
  isOpen,
  title,
  searchText,
  results = [],
  isLoading,
  actionLabel,
  allowCustomDoctor = false,
  onSearchChange,
  onClose,
  onSelect,
}) {
  if (!isOpen) return null;

  const hasQuery = Boolean(searchText?.length);
  const hasResults = results.length > 0;

  return (
    <div className="modal referDoctorModal" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <button
            aria-label={`Close ${title}`}
            className="CloseButton"
            onClick={onClose}
            type="button"
          />
          <h3>{title}</h3>
          <p>
            When a doctor refers a patient to another doctor, it means that the
            referring doctor believes that the patient needs to see a specialist
            or another healthcare professional for further evaluation, diagnosis,
            or treatment.
          </p>
        </div>

        <div className="modal-body">
          <ul className="AddIndicatorList">
            <li>
              <input
                aria-label="Search doctor"
                type="text"
                value={searchText ?? ""}
                placeholder="Enter here to search Doctor..."
                className="form-control"
                onChange={(event) => onSearchChange(event.target.value)}
              />
              {isLoading ? (
                <div className="search-loader toDoctorSearchList">
                  <CircularProgress size={20} />
                </div>
              ) : null}
            </li>
          </ul>

          <div className="search-box">
            {hasQuery && !hasResults ? (
              <h4>0 doctor found</h4>
            ) : null}

            <ul className="search-list">
              {results.map((doctor, index) => (
                <li key={doctorKey(doctor, index)}>
                  <div className="profile-box">
                    <div className="img-sec" />
                    <div className="header-sec">
                      <h5>
                        Dr. {doctor?.first_name} {doctor?.last_name}
                      </h5>
                      <p>{doctor?.name}</p>
                    </div>
                  </div>
                  <button
                    className="ModalCloseBtn"
                    onClick={() => onSelect(doctor)}
                    type="button"
                  >
                    {actionLabel}
                  </button>
                </li>
              ))}

              {allowCustomDoctor && hasQuery && !hasResults && !isLoading ? (
                <li>
                  <div className="profile-box">
                    <div className="img-sec" />
                    <div className="header-sec">
                      <h5>Dr. {searchText}</h5>
                    </div>
                  </div>
                  <button
                    className="ModalCloseBtn"
                    onClick={() => onSelect(null)}
                    type="button"
                  >
                    {actionLabel}
                  </button>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
